import {
    SET_SELECTED_CATEGORY_ID,
    SHOW_CART_MODAEL,
} from './types';

export const setSelectedCategory = categoryId => {
    return {
        type: SET_SELECTED_CATEGORY_ID,
        payload: categoryId
    };
};

export const setCartModalVisibility = visibile => {
    return {
        type: SHOW_CART_MODAEL,
        payload: visibile
    };
};
